import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";

function Header() {
  const { t } = useTranslation();

  return (
    <>
      {/* Title */}
      <h2 className="adminAuth__title">{t("adminLogin.title")}</h2>

      {/* Subtitle */}
      <p className="adminAuth__subtitle">{t("adminLogin.subtitle")}</p>
    </>
  );
}

export default Header;
